var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },
        "& .MuiButton-root": {
            fontSize: "0.7rem"
        },
//.datatables-noprint
    },

}));

export default function ReportProjectLP() {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [expand, setExpand] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(true);

    const classes = pageStyles();
	
	    
	const convertDates = (json) => {
		/*json.forEach(eachObj => {
			if (eachObj.LPStart) {
				eachObj.LPStart = moment.utc(eachObj.LPStart).format("MM/DD/YYYY");
			}
			if (eachObj.LPEnd) {
				eachObj.LPEnd = moment.utc(eachObj.LPEnd).format("MM/DD/YYYY");
			}
		});*/
		setDataSet(json);
	};

    const getData = async () => {
        await fetch('/api/Reports/ProjectLP/', {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
					convertDates(json);
					setIsLoading(false);
				})

    };

    const columns = [
        {
            name: "ProjectGroup",
            label: "ProjectGroup",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "Project",
            label: "Project",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "Lab",
            label: "Lab",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },

        {
            name: "PO",
            label: "PO",
            options: {
                filter: true,
                sort: true,
                filterOptions: {
                    renderValue: val => {
                        if (val === "" || val === null || val === undefined) {
                            return "Not Set";
                        }
                        return val;
                    }
                },
                customBodyRender: (value) => {
                    //      logger(`value`, value)
                    if (value)
                        return (
                            <>{value}</>
                        );
                    else
                        return (
                            <Tooltip title='Failing' className={classes.root}>
                                <ReportGmailerrorredIcon color='error' />
                            </Tooltip>
                        );
                }
            }
        },
        {
            name: "LPStart",
            label: "Coverage Starts",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
                       customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].LPStart).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "LPEnd",
            label: "Coverage Ends",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].LPEnd).format("MM/DD/YYYY")
                    );
                }
            }
        },
       

    ];
    const MakeToolbar = () => {
        //     <Tooltip title="Active Only" placement="right-end">
        return (
            <>
                <Checkbox defaultChecked={expand} color="default" onClick={() => { setExpand(!expand), setRefresh(true); }} />
            </>
        );
        logger("createTB" + MakeToolbar)
    }

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: initialRowsPerPage,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				for (var i = 0; i < dataSet.length; i++) {
					var eachRow = data[i].data;
					eachRow[4] =  moment.utc(eachRow[4]).format("MM/DD/YYYY")
					eachRow[5] =  moment.utc(eachRow[5]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({data:data, headers:headers});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename: 'ProjectLP.xlsx'});
			return false;
		}

};
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setExpand(true);
    };
    React.useEffect(() => {
		checkAuthentication();

        if (refresh) {
         //   logger("expand" + expand)
            getData()

            setRefresh(false);
        }

    })

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div className={classes.root}>
            <Button variant="contained" onClick={handleClickOpen}>
              L&P => PO
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                    <DialogContent >
                        <Box>

                            <MUIDataTable className={classes.root}
                                title={

                                    <Typography variant="h6" style={{ color: "white" }}>
                                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
                                        Project L&P
                                    </Typography>
                                }
                                data={isLoading ? [] :dataSet}
                                columns={columns}
                                options={muiLoaderOptions(options, isLoading)}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}

 